import Vue from 'vue'
import './plugins/axios'
import './plugins/tiptap'
import './plugins/cropper'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import router from './router'
import DashboardLayout from "./layouts/DashboardLayout";

Vue.component('dashboard-layout', DashboardLayout);

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
    created () {
        const userInfo = localStorage.getItem('user')
        if (userInfo) {
            const userData = JSON.parse(userInfo)
            this.$store.commit('auth/setUserData', userData)
        }
        window.axios.interceptors.response.use(
            response => response,
            error => {
                if (error.response.status === 401) {
                    this.$store.dispatch('auth/logout')
                }
                return Promise.reject(error)
            }
        )
    },
  render: h => h(App)
}).$mount('#app')
